import { Contact } from "./Contact";
import _ from "lodash";

export class Trajet {
    id?: number;
    date?: string;
    distance?: Trajet.Distance;

    constructor(data: any) {
        _.assign(this, _.omit(data, ["distance"]));
        if (data.distance) {
            this.distance = new Trajet.Distance(data.distance);
        }
    }
}

export namespace Trajet {
    export class Distance {
        id?: number;
        distance: number = 0;
        status?: Trajet.Distance.EStatus;
        _origin?: Contact;
        _destination?: Contact;

        constructor(data: any) {
            _.assign(this, _.omit(data, ["origin", "destination"]));
            if (data.origin) {
                this._origin = new Contact(data.origin);
            }
            if (data.destination) {
                this._destination = new Contact(data.destination);
            }
        }

        get origin(): Contact | undefined {
            return this._origin;
        }

        get destination(): Contact | undefined {
            return this._destination;
        }
    }

    export namespace Distance {
        export enum EStatus {
            Computed = 0,
            Validated = 1,
            Manual = 2,
        }
    }
}
